import React, { useState } from 'react';
import { FaClock, FaCalendarAlt, FaChartLine } from 'react-icons/fa';
import PropTypes from 'prop-types';
import './css/TimeSalesCards.css';

const TIME_BUCKET_ORDER = ["Morning", "Afternoon", "Evening", "Night"];

const getBucketIndex = (label = "") => {
  const normalized = label.toLowerCase();
  const match = TIME_BUCKET_ORDER.findIndex((bucket) => normalized.includes(bucket.toLowerCase()));
  return match === -1 ? Number.POSITIVE_INFINITY : match;
};

const TimeSalesCards = ({ timeData, events, onEventChange, selectedEvent }) => {
  const handleEventChange = (event) => {
    onEventChange(event.target.value);
  };

  const SHOW_BUCKETS = ["Evening", "Night"];
  const orderedTimeData = [...timeData]
    .filter((slot) => SHOW_BUCKETS.some((b) => slot.time?.toLowerCase().includes(b.toLowerCase())))
    .sort((a, b) => getBucketIndex(a.time) - getBucketIndex(b.time));

  const peakSlot = orderedTimeData.length > 0
    ? orderedTimeData.reduce((max, slot) => (slot.tickets > max.tickets ? slot : max), orderedTimeData[0])
    : null;

  return (
    <section className="time-sales-cards-section">
      <div className="time-sales-header">
        <div className="header-title">
          <FaChartLine className="analysis-icon" />
          <h3>Sales by Time of Day Analysis</h3>
        </div>
        <div className="event-selector">
          <FaCalendarAlt className="selector-icon" />
          <select 
            value={selectedEvent} 
            onChange={handleEventChange}
            className="event-dropdown"
          >
            <option value="all">All Events</option>
            {events.map((event) => (
              <option key={event.id} value={event.id}>
                {event.name} ({event.date})
              </option>
            ))}
          </select>
        </div>
      </div>
      
      <div className="analysis-summary">
        <div className="summary-card">
          <span className="summary-label">Peak Sales Time:</span>
          <span className="summary-value">
            {peakSlot ? peakSlot.time : 'N/A'}
          </span>
        </div>
        <div className="summary-card">
          <span className="summary-label">Total Tickets:</span>
          <span className="summary-value">
            {orderedTimeData.reduce((sum, slot) => sum + slot.tickets, 0).toLocaleString()}
          </span>
        </div>
      </div>

      <div className="time-cards-grid">
        {orderedTimeData.map((timeSlot, index) => (
          <div key={index} className="time-sales-card">
            <div className="time-card-header">
              <FaClock className="time-icon" />
              <h4>{timeSlot.time}</h4>
            </div>
            <div className="time-card-metrics">
              <div className="metric">
                <span className="metric-value">{timeSlot.tickets.toLocaleString()}</span>
                <span className="metric-label">tickets</span>
              </div>
              <div className="metric">
                <span className="metric-value">{timeSlot.percentage}%</span>
                <span className="metric-label">of total</span>
              </div>
            </div>
            <div className="progress-bar">
              <div 
                className="progress-fill" 
                style={{ width: `${timeSlot.percentage}%` }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

TimeSalesCards.propTypes = {
  timeData: PropTypes.arrayOf(
    PropTypes.shape({
      time: PropTypes.string.isRequired,
      tickets: PropTypes.number.isRequired,
      percentage: PropTypes.number.isRequired
    })
  ).isRequired,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired
    })
  ).isRequired,
  onEventChange: PropTypes.func.isRequired,
  selectedEvent: PropTypes.string.isRequired
};

export default TimeSalesCards;
